import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the measurement unit for the Size filter
 * @param {string} sizeUnit - One of SIZE_UNIT values
 */
export const setSizeUnit = (sizeUnit) => {
  searchPageStore.setState({ sizeUnit })
}

const setDimension = (key, axis, value) => {
  const current = searchPageStore.getState()[key] || {}
  searchPageStore.setState({ [key]: { ...current, [axis]: value } })
}

/**
 * Sets a single axis max for the whole print size
 * @param {string} axis - One of SIZE_AXIS values
 * @param {number|string} value - Numeric max, or '' when cleared
 */
export const setWholePrintSize = (axis, value) => {
  setDimension('wholePrintSize', axis, value)
}

/**
 * Sets a single axis max for the largest print size
 * @param {string} axis - One of SIZE_AXIS values
 * @param {number|string} value - Numeric max, or '' when cleared
 */
export const setLargestPrintSize = (axis, value) => {
  setDimension('largestPrintSize', axis, value)
}

/**
 * Sets the Quick Select size preset
 * @param {string|undefined} sizePreset - One of SIZE_PRESET values, or undefined when cleared
 */
export const setSizePreset = (sizePreset) => {
  searchPageStore.setState({ sizePreset })
}

/**
 * Clears all Size filters
 */
export const clearSize = () => {
  searchPageStore.setState({
    sizeUnit: DEFAULT_STATE.sizeUnit,
    wholePrintSize: DEFAULT_STATE.wholePrintSize,
    largestPrintSize: DEFAULT_STATE.largestPrintSize,
    sizePreset: DEFAULT_STATE.sizePreset,
  })
}
